export default __webpack_public_path__ + "static/media/AkkuratLLWeb-Regular.59940514.woff2";